import { message } from "ant-design-vue"
export default {
	methods:{
		showDelConfirm(okfn,tishi="您确定要删除该数据"){
            this.$confirm({
                title:"操作确认提示",
                content:tishi,
                okText:"确定",
                cancelText:"取消",
                onOk:()=>{
					okfn()
                }
            })
        },
		muldelete(slts,delreq){
			if(slts.length == 0){
				message.error({
					content:"请选择要删除的数据",
					duration:1
				})
			}else{
				this.showDelConfirm(()=>{
					let hide = message.loading("正在删除...",1000)
					delreq().then((ret)=>{
						hide()
						if(ret == "success"){
							message.success("删除成功")
						}else{
							message.erro("删除失败")
						}
					}) 
				},"您确定要删除选中数据")
			}
		},
		deletefn(delreq){
			this.showDelConfirm(()=>{
				let hide = message.loading("正在删除...",1000)
				delreq().then((ret)=>{
					hide()
					if(ret == "success"){
						message.success("删除成功")
					}else{
						message.erro("删除失败")
					}
				}) 
			})
        }
	}
}